export default __webpack_public_path__ + "static/media/background2.6ad60c59.jpg";